import React from "react";
import NewIcon from "../../../assets/img/card-icons/newicon.svg";
import NewCalender from "../../../assets/img/card-icons/newcalender.svg";
import NewWhatsapp from "../../../assets/img/card-icons/newwhatsapp.svg";
import { getTelUrl, getWhatsAppUrl } from "./contactLinks";
import "./AtencionInfoWeb.scss";

const AtencionInfoWeb = ({ atencionTelefonica, centralTurno, whatsapp }) => {
  const telAtencion = getTelUrl(atencionTelefonica);
  const telCentral = getTelUrl(centralTurno);
  const urlWhatsapp = getWhatsAppUrl(whatsapp);

  return (
    <div className="atencion-info-web">
      <a
        href={telAtencion}
        className="atencion-header-card atencion-header-card--telefono atencion-contact-link"
        aria-label={`Llamar a atención telefónica 24 horas, ${atencionTelefonica}`}
      >
        <span className="atencion-header-card__icon-wrap" aria-hidden>
          <img src={NewIcon} className="atencion-header-card__icon" alt="" />
        </span>
        <span className="atencion-header-card__body">
          <span className="atencion-header-card__label">
            Atención telefónica las 24hs
          </span>
          <span className="atencion-header-card__number">{atencionTelefonica}</span>
        </span>
      </a>
      <a
        href={telCentral}
        className="atencion-header-card atencion-header-card--turnos atencion-contact-link"
        aria-label={`Llamar a central de turnos, ${centralTurno ?? ""}`}
      >
        <span className="atencion-header-card__icon-wrap" aria-hidden>
          <img src={NewCalender} className="atencion-header-card__icon" alt="" />
        </span>
        <span className="atencion-header-card__body">
          <span className="atencion-header-card__label">Central de turnos</span>
          <span className="atencion-header-card__number">{centralTurno}</span>
        </span>
      </a>
      <a
        href={urlWhatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="atencion-header-card atencion-header-card--whatsapp atencion-contact-link"
        aria-label={`Abrir WhatsApp ${whatsapp ?? ""}`}
      >
        <span className="atencion-header-card__icon-wrap" aria-hidden>
          <img src={NewWhatsapp} className="atencion-header-card__icon" alt="" />
        </span>
        <span className="atencion-header-card__body">
          <span className="atencion-header-card__label">WhatsApp</span>
          <span className="atencion-header-card__number">{whatsapp}</span>
        </span>
      </a>
    </div>
  );
};

export default AtencionInfoWeb;
